export default {
  projectId: `h0t7l0d0`,
  dataset: `production`,
  watchMode: false,
  overlayDrafts: false,
  token:
    "skyYzmax80lNvG6FcNwbL0MKhRwyE56YKW9MpN9U5Wm8bWetB2JtU0xTwhR1McgNV12Dnoe89aRjwUU58S8TUyTJwhndGHYpksj98M5JJCldrNd0iXISa7iA7rboKUNd65HaWvNxC5LqkTkYtT2FDCFpk9eEaMTjwkewylhWpVU3rfWXz9p6",
}
